<template>
  <div class="title-container">
    <div class="legend-title">{{ legendTitle }}</div>
  </div>

  <div class="legend-container">
    <!-- use <img> directly instead of innerHTML -->
    <img class="legend-image" :src="legendSrc" alt="Legend" />
  </div>
</template>

<script setup>
import { computed, defineProps, ref, watchEffect } from 'vue';

// Backend proxy (Django)
const API_BASE = 'https://geoserver-portal.soilslab.ai';
const LEGEND_PROXY_URL = `${API_BASE}/legend`;

// Prop is now a key like "soc", "clay", etc.
const props = defineProps({
  soilProperty: {
    type: String,
    default: 'soc',
  },
});

const soilPropertyToLayer = {
  clay: 'soil_properties:clay_florida_layer',
  cec: 'soil_properties:cec_florida_layer',
  sd: 'soil_properties:sd_florida_layer',
  ph: 'soil_properties:ph_florida_layer',
  soc: 'soil_properties:soc_florida_layer',
  socs: 'soil_properties:socs_florida_layer',
  paw: 'soil_properties:paw_florida_layer',
};

const soilPropertyToTitle = {
  clay: 'Clay Content (g/kg)',
  cec: 'Cation Exchange Capacity (g/kg)',
  sd: 'Soil Density (g/cm³)',
  ph: 'pH Level',
  soc: 'Soil Organic Carbon (g/kg)',
  socs: 'Soil Organic Carbon Sequestration (tn/ha)',
  paw: 'Plant Available Water (m³/m³)',
};

const legendTitle = ref(soilPropertyToTitle.soc);

// Build the legend image URL via your Django proxy
const legendSrc = computed(() => {
  const key = props.soilProperty || 'soc';
  const layerName = soilPropertyToLayer[key] ?? soilPropertyToLayer.soc;

  return `${LEGEND_PROXY_URL}/?layer=${encodeURIComponent(layerName)}&width=30&height=30`;
});

// Keep title in sync with prop
watchEffect(() => {
  const key = props.soilProperty || 'soc';
  legendTitle.value = soilPropertyToTitle[key] ?? 'Legend';
});
</script>

<style scoped>
.title-container {
  position: fixed;
  left: 20px;
  bottom: 20px;
  padding: 10px;
  border-radius: 10px;
  z-index: 2;
  display: flex;
  font-family: courier;
}

.legend-container {
  position: fixed;
  bottom: 30px;
  right: 20px;
  padding: 10px;
  border-radius: 10px;
  z-index: 2;
  display: flex;
}

.legend-title {
  align-self: flex-end;
  padding: 5px;
  border-radius: 5px;
  background-color: #ffffff;
}

.legend-image {
  background-color: #ffffff;
  padding: 5px;
  border-radius: 5px;
}
</style>
